// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".TextInput_root_1OcLc{outline:none;background:#eef2f7;height:38px;border:1px solid #eef2f7;padding:0 16px;color:#313a46;border-radius:3px;transition:border-color .2s ease-in}.TextInput_root_1OcLc.TextInput_compact_36s0x{height:30px;padding:0 8px}.TextInput_root_1OcLc.TextInput_textarea_2bG2B{padding:16px;height:auto}.TextInput_root_1OcLc:focus{border-color:#c2d3ea}.TextInput_root_1OcLc::-webkit-inner-spin-button,.TextInput_root_1OcLc::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.TextInput_root_1OcLc[type=number]{-moz-appearance:textfield}.TextInput_root_1OcLc::-moz-placeholder{color:#8391a2}.TextInput_root_1OcLc::placeholder{color:#8391a2}", ""]);
// Exports
exports.locals = {
	"root": "TextInput_root_1OcLc",
	"compact": "TextInput_compact_36s0x",
	"textarea": "TextInput_textarea_2bG2B"
};
module.exports = exports;
